// Used in localstorage to hold users original destination
export const ORIGINAL_DESTINATION = 'pivots_original_destination_url';

export const LOCALSTORAGE_RCP_VALUE = 'pivots-rcp';
